import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import resources from './index';
import { Language } from './translationModels';
import { logInfo } from '../services/logger';

export const initI18n = async () => {
  logInfo('Setting up i18n ...');

  i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      lng: Language.English,
      resources,
      fallbackLng: Language.English,
      interpolation: {
        escapeValue: false,
      },
    });
};
